
const newModel = () => {
    return {
        loaihinhHanhngheYId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        loaihinhHanhngheYId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,

    }
}

const fromJson = (item) => {
    return {
        loaihinhHanhngheYId: item.loaihinhHanhngheYId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        loaihinhHanhngheYId: item.loaihinhHanhngheYId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        loaihinhHanhngheYId: null,
        ten: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        loaihinhHanhngheYId: item.loaihinhHanhngheYId,
        ten: item.ten,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        loaihinhHanhngheYId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const loaihinhHanhngheYModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


